import { useCallback } from 'react';
import { Modal, notification } from 'tea-component';

/**
 * 删除确认配置
 */
export interface IConfirmDeleteOptions {
  /** 删除操作（返回 Promise） */
  mutate: (...args: any[]) => Promise<any>;
  /** 删除后刷新操作（返回 Promise） */
  refresh?: (...args: any[]) => Promise<any>;
  /** 弹窗标题 */
  caption?: string;
  /** 确认弹窗消息 */
  message?: string;
  /** 确认按钮文字 */
  okText?: string;
  /** 取消按钮文字 */
  cancelText?: string;
  /** 是否显示成功通知 */
  showNotification?: boolean;
  /** 成功通知文字 */
  successMessage?: string;
}

/**
 * 通用删除确认 hook
 * @returns handleConfirmDelete 方法
 * @example
 * const [handleConfirmDelete] = useConfirmDelete();
 * 
 * // 使用示例
 * await handleConfirmDelete({
 *   mutate: () => deleteApi(id),
 *   refresh: () => fetchList(),
 *   message: '确定要删除吗？',
 * });
 */
export const useConfirmDelete = () => {
  const handleConfirmDelete = useCallback(async ({
    mutate,
    refresh,
    caption,
    message = '确定要删除吗？',
    okText = '确认',
    cancelText = '取消',
    showNotification = true,
    successMessage = '删除成功',
  }: IConfirmDeleteOptions): Promise<boolean> => {
    const yes = await Modal.confirm({
      caption,
      message,
      okText,
      cancelText,
      className: 'dba-confirm-modal'
    });

    if (yes) {
      await mutate?.();
      await refresh?.();
      if (showNotification) {
        notification.success({ description: successMessage });
      }
      return true;
    }
    return false;
  }, []);

  return [handleConfirmDelete] as const;
};

